import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigation } from 'cubedist-cube-pipeline-common-ui';
import { useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router-dom';
import { BookmarkBorder as BookmarkBorderIcon } from '@mui/icons-material';
import { CubeNotifications } from 'cnh-components';
import { FeatureFlags } from 'contexts/Features.context';
import { Roles } from 'contexts/Roles.context';
import { UserProfile } from 'contexts/UserProfile.context';
import { ChatbotContext } from 'contexts/Chatbot.context';
import { useCustomNavigate, useUiPreferences } from 'hooks';
import * as S from './NavBar.styles';
import { ReactComponent as IconWhite } from 'assets/IconWhite.svg';

const NavBar = ({ navProps }) => {
  const auth = useAuth();
  const location = useLocation();

  const { features } = useContext(FeatureFlags);
  const { setOpen: setChatbotOpen } = useContext(ChatbotContext);
  const { permissionsExist } = useContext(Roles);
  const { clearUserProfileStorage } = useContext(UserProfile);
  const [notificationMounted, setNotificationMounted] = useState(true);

  const navigate = useCustomNavigate();

  const hasPermission = permissionsExist(['Query']);
  const isLogisticsRole = permissionsExist(['VehicleDetailsLogistics']);

  const { updatePreferences } = useUiPreferences({ skip: !isLogisticsRole });

  const handleMounted = useCallback((mounted) => {
    setNotificationMounted(mounted);
  }, []);

  const handleLogout = () => {
    if (isLogisticsRole) {
      updatePreferences({ vehicleSummaryPanel: { view: 'vehicleInquiry' } });
    }
    clearUserProfileStorage();
    auth.signoutRedirect();
  };

  const showVehicleList =
    location.pathname.includes('vehicle-list') && features?.cnhNotificationsEnabled;

  return (
    <>
      <Navigation
        app="pipeline"
        disableSearch={!features?.globalSearchEnabled}
        disableSubnavItems={navProps?.disableSubnavItems ?? false}
        subnavTitle={
          navProps?.subnavTitle || navProps?.subnavTitle === null
            ? navProps.subnavTitle
            : 'Pipeline'
        }
        isAdmin={hasPermission}
        handleLogout={handleLogout}
        additionalItems={
          showVehicleList
            ? [
                {
                  label: 'Vehicle List',
                  link: '#',
                  nonClickable: true,
                  active: true,
                },
              ]
            : []
        }
        rightSlot={
          <>
            {features?.chatbot && (
              <S.StyledIconButton onClick={() => setChatbotOpen((v) => !v)}>
                <IconWhite />
              </S.StyledIconButton>
            )}
            {features?.bookmarksEnabled && (
              <S.StyledIconButton onClick={() => navigate('/bookmarks')}>
                <BookmarkBorderIcon />
              </S.StyledIconButton>
            )}
            {features?.notifications && notificationMounted && (
              <S.StyledIconButton>
                <CubeNotifications isMounted={(mounted) => handleMounted(mounted)} />
              </S.StyledIconButton>
            )}
          </>
        }
      />
    </>
  );
};

NavBar.propTypes = {
  navProps: PropTypes.shape({
    subnavTitle: PropTypes.string,
    disableSubnavItems: PropTypes.bool,
  }),
};

export default NavBar;
